const ACTION_LABELS: Record<string, string> = {
  reduce: 'Использование',
  sale: 'Продажа',
  credit: 'Добавление на склад',
};

export const COLUMNS = [
  {
    title: 'Склад',
    dataIndex: 'Warehouse',
    key: 'Warehouse',
    width: 120,
  },
  {
    title: 'Товар',
    dataIndex: 'ProductDesc',
    key: 'ProductDesc',
  },
  {
    title: 'Действие',
    dataIndex: 'Action',
    key: 'Action',
    width: 140,
    render: (value: string) => ACTION_LABELS[value] ?? value,
  },
  {
    title: 'Масса / объём',
    dataIndex: 'ActionAmount',
    key: 'ActionAmount',
    width: 140,
  },
  {
    title: 'В кредит',
    dataIndex: 'IsCredit',
    key: 'IsCredit',
    width: 100,
    render: (value: boolean) => (value ? 'да' : ''),
  },
];
